import { assign, createMachine } from 'xstate';
import { ApplicationError } from '../../../components/ApplicationErrorBoundary/errors/ApplicationError';
import { CreateRiskInsightsResponse } from '../../models/riskInsights';
import { RiskInsightsService, riskInsightsService } from '../../services/risk-insights';

type Context = {
  riskInsightReport: CreateRiskInsightsResponse | undefined;
  error: ApplicationError | undefined;
};
type Service = {
  generateRiskInsight: { data: CreateRiskInsightsResponse };
};

export const createRiskInsightsMachine = (service: RiskInsightsService = riskInsightsService) =>
  createMachine(
    {
      id: 'riskInsightsMachine',
      predictableActionArguments: true,
      initial: 'auth',
      schema: {
        context: {} as Context,
        services: {} as Service,
      },
      context: {
        riskInsightReport: undefined,
        error: undefined,
      },
      tsTypes: {} as import('./riskInsightsMachine.typegen').Typegen0,
      states: {
        auth: {
          on: {
            CREDENTIALS: {
              target: 'createReport',
            },
          },
        },
        createReport: {
          invoke: {
            src: 'generateRiskInsight',
            onDone: [
              {
                target: 'success',
                actions: 'saveRiskInsight',
              },
            ],
            onError: [
              {
                target: 'error',
                actions: 'saveError',
              },
            ],
          },
        },
        success: { type: 'final' },
        error: { type: 'final' },
      },
    },
    {
      services: {
        generateRiskInsight: () => {
          return service.createRiskInsights();
        },
      },
      actions: {
        saveRiskInsight: assign({
          riskInsightReport: (_, event) => event.data,
        }),
        saveError: assign({
          error: (_, event) => event.data as ApplicationError,
        }),
      },
    }
  );
